export enum Direction {
  UP,
  DOWN,
  LEFT,
  RIGHT,
}
